import { BaseConfigMerge } from "../table-config";
import { TableColumn, TableColumnDto, parseToTableColumnDto } from "./header.type";


// eslint-disable-next-line @tseslint/typedef
const TABLE_COLUMN_CONFIG_DTO_DISCRIMINATOR = "table-column-config";

export interface BaseTableColumnConfig {
  fieldsSortedByOptions: string[];
}
export interface TableColumnConfigDto extends BaseTableColumnConfig {
  discriminator: typeof TABLE_COLUMN_CONFIG_DTO_DISCRIMINATOR;
  headers: TableColumnDto[];
}
export interface TableColumnConfigPayloadDto {
  configJson: string;
}
export interface TableColumnConfig extends BaseTableColumnConfig {
  columns: TableColumn[];
}
export function parseToColumnConfigDto (config: TableColumnConfig): TableColumnConfigPayloadDto {
  return { configJson: JSON.stringify({ ...config, headers: config.columns.map(parseToTableColumnDto), discriminator: TABLE_COLUMN_CONFIG_DTO_DISCRIMINATOR } satisfies TableColumnConfigDto) };
}
export function mergeTableColumnConfig (config: TableColumnConfigDto, mergeBase: TableColumnConfig): TableColumnConfigMerge {
  let wasUpdated: boolean = false;

  const headers: TableColumn[] = [];

  for (const header of config.headers) {
    const matchingHeader: TableColumn | undefined = mergeBase.columns.find((h: TableColumnDto) => h.field === header.field);

    if (!matchingHeader) {
      wasUpdated = true;

      continue;
    }

    matchingHeader.options = header.options;
    headers.push(matchingHeader);
  }

  for (const header of mergeBase.columns) {
    if (!headers.some((matchingHeader: TableColumn) => matchingHeader.field === header.field)) {
      headers.push(header);
      wasUpdated = true;
    }
  }

  return { wasUpdated, mergedConfig: { ...config, columns: headers } };
}
export interface TableColumnConfigMerge extends BaseConfigMerge {
  mergedConfig: TableColumnConfig;
}
export function isTableColumnConfigDto (value: unknown): value is TableColumnConfigDto {
  if (typeof value !== 'object' || !value) return false;

  if (!Object.hasOwn(value, 'discriminator')) return false;

  // eslint-disable-next-line @tseslint/no-explicit-any, @tseslint/no-unsafe-member-access
  return (value as any).discriminator === TABLE_COLUMN_CONFIG_DTO_DISCRIMINATOR;
}
